var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper pa-6" },
    [
      _c("v-card", [
        _c("div", { staticClass: "num" }, [_vm._v("1.")]),
        _vm._v(" "),
        _c("div", { staticClass: "titolo" }, [_vm._v("Crea Asta")]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "separatore" },
        [_c("v-icon", [_vm._v("expand_more")])],
        1
      ),
      _vm._v(" "),
      _c("v-card", [
        _c("div", { staticClass: "num" }, [_vm._v("2.")]),
        _vm._v(" "),
        _c("div", { staticClass: "titolo" }, [
          _vm._v("Invita gli altri partecipanti"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "separatore" },
        [_c("v-icon", [_vm._v("expand_more")])],
        1
      ),
      _vm._v(" "),
      _c("v-card", [
        _c("div", { staticClass: "num" }, [_vm._v("3.")]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "titolo" }, [
            _vm._v("Decidete giorno/ora dell'asta"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "v-icon",
                { staticClass: "white--text", attrs: { right: "", small: "" } },
                [_vm._v("warning")]
              ),
              _vm._v(
                " Questa\n        decisione non viene presa in Asta Live, dovete accordarvi per conto\n        vostro\n      "
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "separatore" },
        [_c("v-icon", [_vm._v("expand_more")])],
        1
      ),
      _vm._v(" "),
      _c("v-card", [
        _c("div", { staticClass: "num" }, [_vm._v("4.")]),
        _vm._v(" "),
        _c("div", { staticClass: "titolo" }, [
          _vm._v("Tutti online il giorno dell'asta!"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "separatore" },
        [_c("v-icon", [_vm._v("expand_more")])],
        1
      ),
      _vm._v(" "),
      _c("v-card", [
        _c("div", { staticClass: "num" }, [_vm._v("5.")]),
        _vm._v(" "),
        _c("div", { staticClass: "titolo" }, [
          _vm._v("Amministratore fa partire l'asta"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "separatore" },
        [_c("v-icon", [_vm._v("expand_more")])],
        1
      ),
      _vm._v(" "),
      _c("v-card", [
        _c("div", { staticClass: "num" }, [_vm._v("6.")]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "titolo secondary--text" }, [
            _vm._v("Et voilà!"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "titolo" }, [
            _vm._v("Da adesso in poi ti guiderà Asta Live!"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-4 sottotitolo" },
            [
              _c("v-icon", { staticClass: "secondary--text" }, [
                _vm._v("chevron_right"),
              ]),
              _vm._v(
                " Se tocca a te\n        fare offerta ti si apriranno popup intuitivi. "
              ),
              _c("br"),
              _vm._v(
                '\n        Ma occhio al timer! Se scade il tempo, "passi"!\n      '
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-4 sottotitolo" },
            [
              _c(
                "v-icon",
                { staticClass: "secondary--text", attrs: { right: "" } },
                [_vm._v("chevron_right")]
              ),
              _vm._v(
                " Se non\n        tocca a te, puoi seguire l'andamento dell'asta sul tavolo virtuale.\n      "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4" }, [
            _vm._v(
              "\n        Man mano che l'asta prosegue, Asta Live aggiornerà rose, crediti,\n        offerte massime in tempo reale\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4" }, [
            _vm._v("\n        Massima flessibilità: "),
            _c("br"),
            _vm._v(
              "\n        L'amministratore può mettere in pausa l'asta, annullare e far\n        ripartire il round o, "
            ),
            _c("br"),
            _vm._v(
              "\n        se necessario, annullare un'assegnazione.\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "separatore" },
        [_c("v-icon", [_vm._v("expand_more")])],
        1
      ),
      _vm._v(" "),
      _c("v-card", [
        _c("div", { staticClass: "num" }, [_vm._v("7.")]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "titolo" }, [_vm._v("Esporta le rose")]),
          _vm._v("\n      Al termine dell'asta esporta le rose in Excel\n    "),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }